module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('ul', {
    staticClass: "posts-list"
  }, _vm._l((_vm.topics), function(item) {
    return _c('li', [_c('div', {
      staticClass: "summary "
    }, [_c('div', {
      staticClass: "details"
    }, [_c('div', [(item.top) ? _c('span', {
      staticClass: "top-topic"
    }, [_vm._v("置顶")]) : (item.good) ? _c('span', {
      staticClass: "top-topic"
    }, [_vm._v("精华")]) : (_vm.menus[item.tab]) ? _c('span', {
      staticClass: "top-topic not-top"
    }, [_vm._v(_vm._s(_vm.menus[item.tab].title))]) : _vm._e(), _vm._v(" "), _c('h2', [_c('a', {
      on: {
        "click": function($event) {
          _vm.getDetail(item.id)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(item.title) + "\n                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "tags"
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-comments-o"
    }), _vm._v(" " + _vm._s(item.reply_count) + "\n                  ")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" " + _vm._s(item.visit_count) + "\n                  ")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm._f("getLastTime")(item.last_reply_at)) + "\n                  ")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "fa fa-user-circle-o"
    }), _vm._v(" " + _vm._s(item.author.loginname) + "\n                  ")])])])])])
  })), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading-content"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/loading.gif")
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-4c253290"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 153
// module chunks = 1